// extracted by mini-css-extract-plugin
export default {"container":"container__CcO3X","cardTitle":"cardTitle__pYZud","cardBody":"cardBody__clzki","message":"message__EzG5e"};